import React from 'react';
import SearchInput from '../shared/SearchInput';

const TYPE_OPTIONS = [
  { value: '', label: 'Todos los tipos' },
  { value: 'tarea', label: 'Tarea' },
  { value: 'reunion', label: 'Reunión' },
  { value: 'decision', label: 'Decisión' },
  { value: 'aprendizaje', label: 'Aprendizaje' },
  { value: 'riesgo', label: 'Riesgo' },
  { value: 'otro', label: 'Otro' },
];

const STATUS_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'true', label: 'Procesados' },
  { value: 'false', label: 'Sin clasificar' },
];

function EntriesFilters({ filters, onChange }) {
  function set(key, val) {
    onChange({ ...filters, [key]: val, page: 1 });
  }

  return (
    <div className="filters-bar">
      <SearchInput
        value={filters.search}
        onChange={val => { set('search', val); }}
        placeholder="Buscar predicados…"
        style={{ flex: 1, minWidth: 140 }}
      />
      <select className="filter-select" value={filters.type} onChange={e => set('type', e.target.value)}>
        {TYPE_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      <select className="filter-select" value={filters.classified} onChange={e => set('classified', e.target.value)}>
        {STATUS_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </div>
  );
}

export default EntriesFilters;
